'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelQHelpers = exports.logQPromiseIssuesAndSendNonApiAlerts = exports.logQPromiseIssuesAndSendAlerts = exports.logQPromiseIssuesToConsole = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INVALID_REJECTION_SUFFIX = '(invalid promise rejection error with no stack since not instanceof Error)';

var NO_STACK_REGEX = /^\(no stack\) /;

var DONE_REJECTION_PREFIX = '[Q Done]';

var SHORT_POLLING_TIMEOUT = 1000;

var MEDIUM_POLLING_TIMEOUT = 5000;

var UNHANDLED_PREFIX = '[Q Unhandled]';

var HAPIJS_REASON_REGEX = /^Error: API request to /;

var HUBHTTP_REASON_REGEX = /^Error: Request for /;

function sendErrorToNewRelicHelper(error, message, extras) {
  // New Relic is only on the window if it is enabled (most of the time, only in production)
  if (window.newrelic && window.newrelic.noticeError) {
    // New Relic uses the same API to send errors or strings
    if (error instanceof Error) {
      window.newrelic.noticeError(error);
    } else if (message != null && message !== '') {
      window.newrelic.noticeError(message);
    } else {
      window.newrelic.noticeError(new Error('sendErrorToNewRelicHelper() called without any error or message'));
    }
  }
}

function sendErrorToSentryHelper(error, message, extras, tags) {
  // Assume the app has correctly set up Raven to send to Sentry (by default Raven is available but
  // disabled for local development)
  if (window.Raven && window.Raven.captureException && window.Raven.captureMessage) {
    var moreInfo = { extra: extras, tags: tags };

    if (error instanceof Error) {
      window.Raven.captureException(error, moreInfo);
    } else if (message != null && message !== '') {
      window.Raven.captureMessage(message, moreInfo);
    } else {
      window.Raven.captureMessage('sendErrorToSentryHelper() called without any error or message');
    }
  }
}

function getMessageStringAndExtrasFromError(error, _ref) {
  var messagePrefix = _ref.messagePrefix,
      messageSuffix = _ref.messageSuffix,
      tags = _ref.tags;

  var result = {
    message: undefined,
    extras: {}
  };

  if (messagePrefix != null) {
    messagePrefix = messagePrefix + ' ';
  } else {
    messagePrefix = '';
  }

  if (messageSuffix != null) {
    messageSuffix = ' ' + messageSuffix;
  } else {
    messageSuffix = '';
  }

  if (tags != null) {
    result.tags = tags;
  }

  if (error != null && typeof error.message === 'string') {
    result.message = '' + messagePrefix + error.message + messageSuffix;
    error.message = result.message; // Also modify the actual error message
  } else if (typeof error === 'string') {
    result.message = '' + messagePrefix + error + messageSuffix;
  } else {
    result.message = '' + messagePrefix + messageSuffix;
  }

  // Pass along extra info than just a message to Raven (not supported by New Relic)
  if (error != null) {
    try {
      result.extras.stringifiedMessage = JSON.stringify(error);
    } catch (jsonError) {
      result.extras.toStringedMessage = String(error);
    }
  }

  return result;
}

function sendErrorToSentryAndNewRelic(error) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (error != null) {
    var _getMessageStringAndE = getMessageStringAndExtrasFromError(error, options),
        message = _getMessageStringAndE.message,
        extras = _getMessageStringAndE.extras,
        tags = _getMessageStringAndE.tags;

    sendErrorToSentryHelper(error, message, extras, tags);
    sendErrorToNewRelicHelper(error, message, extras);
  }
}

function isInvalidRejection(reason) {
  // Q prefixes the reason with '(no stack)' if the rejection came from a non-Error
  return NO_STACK_REGEX.test(reason);
}

function removeNoStackPrefix(reason) {
  return reason.replace(NO_STACK_REGEX, '');
}

var sendCleanedErrorNotificationsWithPrefix = function sendCleanedErrorNotificationsWithPrefix(prefix, tags) {
  return function (reason) {
    var options = {
      messagePrefix: prefix,
      tags: tags
    };

    if (isInvalidRejection(reason)) {
      reason = removeNoStackPrefix(reason);
      options.messageSuffix = INVALID_REJECTION_SUFFIX;
    }

    sendErrorToSentryAndNewRelic(reason, options);
  };
};

// Only calls func for non-API related rejection reasons.
// The heuistic is a bit hacky, but gets the job done
var ifNonApiReason = function ifNonApiReason(func) {
  return function (reason) {
    if (!HUBHTTP_REASON_REGEX.test(reason) && !HAPIJS_REASON_REGEX.test(reason)) {
      func(reason);
    }
  };
};

var hasRequestIdleCallback = window.requestIdleCallback;

var lazyCheck = hasRequestIdleCallback ? function (func) {
  return requestIdleCallback(func);
} : function (func) {
  return func();
};

function scheduleFunctionOnLazyInterval(jobFunc, timeout) {
  var timeoutId = void 0,
      idleId = void 0;

  var wrappedFunc = function wrappedFunc() {
    idleId = lazyCheck(function () {
      jobFunc();
      timeoutId = setTimeout(wrappedFunc, timeout);
    });
  };

  timeoutId = setTimeout(wrappedFunc, timeout);

  // Return a cancel function
  return function () {
    clearTimeout(timeoutId);

    if (idleId && window.cancelIdleCallback) {
      window.cancelIdleCallback(idleId);
    }
  };
}

var ifDeployedAndProduction = function ifDeployedAndProduction(service) {
  return _enviro2.default.deployed(service) && _enviro2.default.getShort(service) === 'prod';
};

var sendUnhandledErrorNotifications = sendCleanedErrorNotificationsWithPrefix(UNHANDLED_PREFIX, { type: 'q-unhandled' });

var checkUnhandled = function checkUnhandled() {
  for (var _len = arguments.length, errorFuncs = Array(_len), _key = 0; _key < _len; _key++) {
    errorFuncs[_key] = arguments[_key];
  }

  return function () {
    var unhandled = _q2.default.getUnhandledReasons();

    // Clear out all existing unhandled rejections
    if (unhandled && unhandled.length > 0) {
      unhandled.forEach(function (unhandledError) {
        return errorFuncs.forEach(function (errorFunc) {
          return errorFunc(unhandledError);
        });
      });

      _q2.default.resetUnhandledRejections();
    }
  };
};

function shortLocalTimeoutButLongerWhenProdAndDeployed() {
  if (ifDeployedAndProduction('unhandledPoller')) {
    return MEDIUM_POLLING_TIMEOUT;
  } else {
    return SHORT_POLLING_TIMEOUT;
  }
}

var determineTimeout = function determineTimeout() {
  var integerOrFunc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shortLocalTimeoutButLongerWhenProdAndDeployed;

  if (typeof integerOrFunc === 'function') {
    var result = integerOrFunc();

    if (typeof result !== 'number') {
      throw new Error('Invalid timeout returned from custom timeout function passed to logUnhandledErrors* call');
    }

    return result;
  } else if (typeof integerOrFunc === 'number') {
    return integerOrFunc;
  } else {
    throw new Error('Invalid timeout passed to logUnhandledErrors* call');
  }
};

// Only allow one handler at a time
var currentCancelFunc = void 0;

function cancelUnhandledPolling() {
  if (currentCancelFunc) {
    currentCancelFunc();
    currentCancelFunc = undefined;
  }
}

function logUnhandledErrorsToConsole() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeout = determineTimeout(options.timeout);
  cancelUnhandledPolling();

  currentCancelFunc = scheduleFunctionOnLazyInterval(checkUnhandled(logToConsole), timeout);
}

function logUnhandledErrorsAndSendAlerts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeout = determineTimeout(options.timeout);
  cancelUnhandledPolling();

  currentCancelFunc = scheduleFunctionOnLazyInterval(checkUnhandled(logToConsole, sendUnhandledErrorNotifications), timeout);
}

function logUnhandledErrorsAndSendNonApiAlerts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeout = determineTimeout(options.timeout);
  cancelUnhandledPolling();

  currentCancelFunc = scheduleFunctionOnLazyInterval(checkUnhandled(logToConsole, ifNonApiReason(sendUnhandledErrorNotifications)), timeout);
}

function logToConsole(reason) {
  if (isInvalidRejection(reason)) {
    console.error(DONE_REJECTION_PREFIX, removeNoStackPrefix(reason), INVALID_REJECTION_SUFFIX);
  } else {
    console.error(DONE_REJECTION_PREFIX, reason);
  }
}

var sendQDoneErrorNotifications = sendCleanedErrorNotificationsWithPrefix(DONE_REJECTION_PREFIX, { type: 'q-done' });

function onQError() {
  for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }

  if (typeof Raven === 'undefined' && typeof newrelic === 'undefined') {
    console.error('Q onerror handlers require Raven or New Relic to be already loaded/setup');
  } else if (typeof _q2.default === 'undefined') {
    console.error('Q onerror handlers require Q be already included and available globally');
  } else {
    _q2.default.onerror = function (err) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = funcs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var func = _step.value;

          func(err);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };
  }
}

function logDoneRejectionsToConsole() {
  onQError(logToConsole);
}

function logDoneRejectionsAndSendAlerts() {
  onQError(logToConsole, sendQDoneErrorNotifications);
}

function logDoneRejectionsAndSendNonApiAlerts() {
  onQError(logToConsole, ifNonApiReason(sendQDoneErrorNotifications));
}

function cancelDoneRejectionHandler() {
  delete _q2.default.onerror;
}

function betterRejectionString(reason) {
  var outputString;

  if (reason == null || typeof reason === 'string' || reason instanceof String) {
    outputString = reason;
  } else if (reason instanceof Error) {
    // Error.prototype.toString is already pretty good (it includes the error type and message)
    outputString = reason + '';
  } else if (reason.message != null) {
    // A error-like object
    outputString = reason.message;
  } else if (reason.responseText != null) {
    // An XHR or XHR-like object
    outputString = reason.responseText;
  } else if (reason.statusText != null) {
    // An XHR or XHR-like object
    outputString = reason.statusText;
  } else if (typeof reason === 'function') {
    outputString = 'Function: ' + reason.toString();
  } else if (reason.constructor != null && reason.constructor.name != null && reason.constructor.name !== 'Object' && reason.constructor.name !== 'Boolean' && reason.constructor.name !== 'Number' && reason.constructor.name !== 'Array' && reason.constructor.name !== 'Date') {
    // constructor.name can be a bit generic, but is useful for non-basic types such DOM/React events,
    // which often are not able to be stringified easily
    outputString = reason.constructor.name;
  } else if (!Object.keys || // Short circuit and don't get to Object.keys if it is missing
  (typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object' || // or if the reason isn't an object, while ...
  Object.keys(reason).length < 100 // Preventing us from stringify-ing giant objects
  ) {
      try {
        outputString = JSON.stringify(reason);
      } catch (e) {
        outputString = reason + '';
      }
    } else {
    outputString = reason + '';
  }

  return outputString;
}

if (!_enviro2.default.deployed('q')) {
  _q2.default.longStackSupport = true;
}

_q2.default.customizeRejectionString = betterRejectionString;

var willCallBoth = function willCallBoth(func1, func2) {
  return function () {
    func1();
    func2();
  };
};

var logQPromiseIssuesToConsole = willCallBoth(logDoneRejectionsToConsole, logUnhandledErrorsToConsole);

var logQPromiseIssuesAndSendAlerts = willCallBoth(logDoneRejectionsAndSendAlerts, logUnhandledErrorsAndSendAlerts);

var logQPromiseIssuesAndSendNonApiAlerts = willCallBoth(logDoneRejectionsAndSendNonApiAlerts, logUnhandledErrorsAndSendNonApiAlerts);

var cancelQHelpers = function cancelQHelpers() {
  cancelDoneRejectionHandler();
  cancelUnhandledPolling();
};

exports.logQPromiseIssuesToConsole = logQPromiseIssuesToConsole;
exports.logQPromiseIssuesAndSendAlerts = logQPromiseIssuesAndSendAlerts;
exports.logQPromiseIssuesAndSendNonApiAlerts = logQPromiseIssuesAndSendNonApiAlerts;
exports.cancelQHelpers = cancelQHelpers;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-6.19/js/handlers.js
// module id = 635
// module chunks = 177